import React, { useState } from 'react'
import { isAgentLogin, isCarrierLogin } from 'tools/auth'
import RadiusOfOperationFilter from '../radiusOfOperation/radiusOfOperationFilter'
import strings from 'strings'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'
import { useEnsureInvitingCompanyId } from 'hooks/useEnsureInvitingCompanyId'
import { useCarrierCodeBootstrap } from 'hooks/useCarrierCodeBootstrap'

interface INbRadiusOfOperationProps {
  locale: 'en' | 'fr'
}

/**
 * NB Fleet View ROO. Garaging zipcode configuration is intentionally
 * unavailable here; it remains on the insurer default carrier-details ROO only.
 */
const NbRadiusOfOperation: React.FC<INbRadiusOfOperationProps> = ({
  locale,
}) => {
  const ensuredInvitingCompanyId = useEnsureInvitingCompanyId()
  const carrierData = useCarrierCodeBootstrap()

  const [embedKey, setEmbedKey] = useState(0)

  const isAgentOrCarrier = isCarrierLogin() || isAgentLogin()
  const invitingCompanyId = isAgentOrCarrier
    ? ensuredInvitingCompanyId
    : undefined
  const carrierId = !isCarrierLogin()
    ? carrierData.carrierId || undefined
    : undefined
  return (
    <ConsoleEmbed
      key={embedKey}
      reportKey={REPORT_KEYS.NB_FLEET_RADIUS}
      invitingCompanyId={invitingCompanyId}
      carrierId={carrierId}
      locale={locale === 'fr' ? 'fr-CA' : 'en-US'}
      distanceUnit="km"
      slots={{
        top: (
          <RadiusOfOperationFilter
            onButtonClick={() => {}}
            reloadDashboard={() => setEmbedKey((k) => k + 1)}
            useKilometers={true}
            garagingZipcodeConfigurationEnabled={false}
            garagingZipcodeLabel={
              strings.NB_SUMMARY_REPORT.ACTIVE_UNITS.GARAGING_ZIPCODE
            }
            carrierId={carrierData.carrierId}
            carrierCodeType={carrierData.carrierCodeType}
            carrierCodeValue={carrierData.carrierCodeValue}
          />
        ),
      }}
    />
  )
}

export default NbRadiusOfOperation
